import { Injectable } from '@angular/core';
import { ItemProfitabilityRow } from './item-profitability-row';
import { ComponentStore } from '@ngrx/component-store';
import {  tapResponse } from '@ngrx/operators';
import { ProductCategoryService } from '../../shared/services/product-category.service';
import { ProductService } from '../../shared';
import { map, mergeMap } from 'rxjs/operators';
import { pipe } from 'rxjs';
import { ReportService } from '../shared/services/report.service';

type FilterBy = null | 'product' | 'category';

interface State {
  results: ItemProfitabilityRow[] | null;
  products: { name: string; id: number }[];
  categories: { name: string; id: number }[];
  loadingResults: boolean;
}

const defaultState: State = {
  results: null,
  products: [],
  categories: [],
  loadingResults: false
};

@Injectable()
export class ItemProfitibilityReportStoreService extends ComponentStore<State> {
  constructor(
    private categoryService: ProductCategoryService,
    private productService: ProductService,
    private reportService: ReportService
  ) {
    super(defaultState);
  }

  private readonly getProducts = this.effect(() =>
    this.productService.getProducts().pipe(
      map((products) => products.map(({ name, id }) => ({ name, id }))),
      tapResponse(
        (products: { name: string; id: number }[]) =>
          this.patchState({ products }),
        (e) => console.log(e)
      )
    )
  );
  private readonly getCategories = this.effect(() =>
    this.categoryService.getProductCategories().pipe(
      map((products) => products.map(({ name, id }) => ({ name, id }))),
      tapResponse(
        (categories: { name: string; id: number }[]) =>
          this.patchState({ categories }),
        (e) => console.log(e)
      )
    )
  );

  readonly products$ = this.select(({ products }) => products);
  readonly categories$ = this.select(({ categories }) => categories);
  readonly loadingResults$ = this.select(
    ({ loadingResults }) => loadingResults
  );
  readonly results$ = this.select(({ results }) => results);

  readonly setFilterBy = this.updater<FilterBy>((state, filterBy) => ({
    ...state,
    filterBy
  }));

  readonly setFilterId = this.updater<number>((state, filterById) => ({
    ...state,
    filterById
  }));

  readonly getResults = this.effect<
    Partial<{
      filterBy: string | null;
      filterId: number | null;
      labourCost: number | null;
    }>
  >(
    pipe(
      mergeMap(({ filterBy, filterId, labourCost }) => {
        const qsParts = [];
        if (filterBy && filterId) {
          const part =
            {
              category: 'product_category_id',
              product: 'product_id'
            }[filterBy] +
            '=' +
            filterId;
          qsParts.push(part);
        }
        if (labourCost) {
          qsParts.push(`labour_cost_hour=${labourCost}`);
        }
        return this.reportService.getItemProfitability(
          qsParts.length ? `?${qsParts.join('&')}` : ''
        );
      }),
      tapResponse(
        (results: ItemProfitabilityRow[]) => this.patchState({ results }),
        (err) => console.log(err)
      )
    )
  );
}
